/** URL language is presentation state; stream IDs, access tokens and API paths are not localized. */
export const localeCodes = ['en','zh-CN','hi','es','ar','bn','pt','ru','ur','fr','de','ja','tr','ta','te','fa','id','mr','vi','ko','it','th','gu','pl','uk','ms','nl','ro','zh-TW'] as const;
export function pageLocale(pathname: string): typeof localeCodes[number] | undefined {
  const first = pathname.replace(/^\/app(?=\/|$)/, '').split('/')[1];
  return localeCodes.find(code => code === first);
}
export function unlocalizedPath(pathname: string): string {
  const code = pageLocale(pathname);
  if (!code) return pathname;
  return pathname.replace(new RegExp(`^(/app)?/${code}(?=/|$)`), '$1') || '/';
}
export function localizedPath(pathname: string, code: string): string {
  if (!localeCodes.includes(code as typeof localeCodes[number])) return pathname;
  const path = unlocalizedPath(pathname);
  const base = /^\/app(?=\/|$)/.test(path) ? '/app' : '';
  const rest = base ? path.slice(base.length) : path;
  return `${base}/${code}${rest === '/' ? '' : rest}`;
}
